module.exports = __webpack_public_path__ + "media/images/athletes/3584-54f5062182128215e0f51fcb2ba1fe16.png";